import { useDataSubmit, useDataValue } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'selected',
  })

  let selected = useDataValue({
    viewPath: props.viewPath,
    context: 'selected',
  })

  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onClick() {
    if (selected.subscriber?.id) {
      await submit({ type: 'remove-subscriber' })
    } else if (selected.bulk_user_ids.length > 0) {
      await submit({ type: 'remove-subscribers' })
    }

    setFlowTo(normalizePath(props.viewPath, '../../No'))
  }
}
